import { readinessParts, type BillingReadiness } from '@immoaktas/shared';

type TFn = (key: string, opts?: Record<string, unknown>) => string;

/** The one readiness sentence of a billing year: "3 von 12 Kostenarten fehlen noch · 2 Belege prüfen" (shared measure). */
export const readinessText = (t: TFn, r: BillingReadiness) =>
  readinessParts(r)
    .map((p) => t(p.key, p.params))
    .join(' · ');
